import { SocketData } from 'actions/socket/socketReceiveDataAction'
import {
  MessengerItemTypes,
  SUPPORT_BOT_PROFILE_ID,
} from 'components/page/Chat/Messenger/Messenger.constants'
import {
  ChatMessengerState,
  MessageFromCometContent,
} from 'reducers/messenger/ChatMessengerState'
import { isTimestampIncorrect } from 'reducers/messenger/function/isTimestampIncorrect'

import { fixBackendMessage } from './fixBackendMessage'

/**
 * Исходящее (после отправки сообщения юзером) обновление данных чата.
 */
export const updateChatDataFromOutgoing = (
  outgoingMessage: SocketData<MessageFromCometContent>,
  chatState: ChatMessengerState
): ChatMessengerState => {
  /**
   * Фильтр по таймштампу был добавлен в рамках:
   * https://redmine.mamba.ru/issues/111709
   *
   * Изменение фильтра в рамках:
   * https://youtrack.mamba.ru/issue/M-5938
   */
  if (
    isTimestampIncorrect(
      chatState,
      Number(outgoingMessage.content.contact?.lastMessageTimestamp)
    )
  ) {
    return { ...chatState }
  }

  if (
    Boolean(chatState.chatData.chatBlockedKey) &&
    outgoingMessage.content.contact.lastMessage!.type ===
      MessengerItemTypes.Gift &&
    chatState.selectedProfileId !== SUPPORT_BOT_PROFILE_ID
  ) {
    return {
      ...chatState,
      forceRefetch: true,
      updateContacts: true,
    }
  } else {
    if (
      outgoingMessage.content.contact.lastMessage!.user_to_id ===
      chatState.selectedProfileId
    ) {
      fixBackendMessage(outgoingMessage.content)

      return {
        ...chatState,
        chatData: {
          ...chatState.chatData,
          ...outgoingMessage.content.contact,
          anketa: {
            ...chatState.chatData.anketa!,
            ...outgoingMessage.content.contact.anketa,
          },
        },
        updateContacts: true,
      }
    }

    console.warn('Last user outgoing chat update skipped', outgoingMessage)

    return chatState
  }
}
